import { Modal, Box, Skeleton } from '@mui/material';
import { OutfitHeader } from '@/components/blocks/ModalOutfits/parts/OutfitHeader';
import { OutfitImage } from '@/components/blocks/ModalOutfits/parts/OutfitImage';
import { OutfitFooter } from '@/components/blocks/ModalOutfits/parts/OutfitItem/parts/OutfitFooter';
import { OutfitList } from '@/components/blocks/ModalOutfits/parts/OutfitList';
import {
	OutfitStagesBodySx,
	OutfitStagesFooterSx,
	OutfitStagesHeaderSx,
	OutfitStagesImageZoneSx,
	OutfitStagesListSkeletonSx,
	OutfitStagesListZoneSx,
	OutfitStagesModalContentSx,
	OutfitStagesModalInnerSx,
	OutfitStagesModalRootSx,
	OutfitStagesModalSx,
} from '@/components/blocks/ModalOutfits/styles/stages';

interface OutfitStagesProps {
	image: string;
	isLoadingData: boolean;
}

export const OutfitStages: React.FC<OutfitStagesProps> = ({ image, isLoadingData }) => {
	return (
		<Modal
			open
			sx={OutfitStagesModalSx}
			disableScrollLock
			onClose={() => {}}
			slotProps={{
				root: {
					sx: OutfitStagesModalRootSx,
				} as any,
			}}
		>
			<Box sx={OutfitStagesModalInnerSx}>
				<Box sx={OutfitStagesModalContentSx}>
					<Box sx={OutfitStagesHeaderSx}>
						<OutfitHeader />
					</Box>
					<Box sx={OutfitStagesBodySx}>
						<Box sx={OutfitStagesImageZoneSx}>
							<OutfitImage image={image} />
						</Box>
						<Box sx={OutfitStagesListZoneSx}>
							{isLoadingData ? (
								<Skeleton variant="rectangular" sx={OutfitStagesListSkeletonSx} />
							) : (
								<OutfitList />
							)}
						</Box>
					</Box>
					<Box sx={OutfitStagesFooterSx}>
						<OutfitFooter />
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};
